import { render, staticRenderFns } from "./Businessgroup.vue?vue&type=template&id=66b295be&scoped=true&"
import script from "./Businessgroup.vue?vue&type=script&lang=js&"
export * from "./Businessgroup.vue?vue&type=script&lang=js&"
import style0 from "./Businessgroup.vue?vue&type=style&index=0&id=66b295be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b295be",
  null
  
)

export default component.exports